import { useEffect, useCallback } from 'react';

// Water / wave glyphs — weighted toward the wavy ones
const CHARS = ['~', '~', '~', '≈', '≈', '∿', '∼', '·', '°', '∘', '○', '〰'];

// Mostly white; pale blue hints for depth
const COLORS = [
  '#ffffff', '#ffffff', '#ffffff', '#ffffff',
  '#f0f8ff', // alice blue
  '#e4f0ff', // barely blue
  '#ddeeff', // soft blue-white
];

export default function CursorSparkle() {
  const spawnSparkle = useCallback((x, y) => {
    const el = document.createElement('span');
    el.className = 'cursor-sparkle';
    el.textContent = CHARS[Math.floor(Math.random() * CHARS.length)];

    // Tight scatter — particles feel like they originate at the cursor tip
    const scatter = 7;
    el.style.left  = `${x + (Math.random() - 0.5) * scatter * 2}px`;
    el.style.top   = `${y + (Math.random() - 0.5) * scatter * 2}px`;
    el.style.color = COLORS[Math.floor(Math.random() * COLORS.length)];
    el.style.fontSize = `${Math.random() * 10 + 14}px`;

    // Circular outward ripple with a gentle upward bias (like rising water)
    const angle  = Math.random() * Math.PI * 2;
    const radius = Math.random() * 30 + 14;
    el.style.setProperty('--sdx', `${Math.cos(angle) * radius}px`);
    el.style.setProperty('--sdy', `${Math.sin(angle) * radius - 14}px`); // bias up

    // Wobble amount — drives the S-curve in the keyframe
    el.style.setProperty('--wb', `${(Math.random() - 0.5) * 18}px`);

    // Vary lifetime slightly for an organic, un-synchronized feel
    el.style.animationDuration = `${(Math.random() * 0.3 + 0.85).toFixed(2)}s`;

    document.body.appendChild(el);
    el.addEventListener('animationend', () => el.remove(), { once: true });
  }, []);

  useEffect(() => {
    let lastTime = 0;
    let lastX = 0;
    let lastY = 0;

    const onMove = (e) => {
      const now  = Date.now();
      const dist = Math.hypot(e.clientX - lastX, e.clientY - lastY);

      if (now - lastTime > 30 && dist > 5) {
        spawnSparkle(e.clientX, e.clientY);
        spawnSparkle(e.clientX, e.clientY);
        spawnSparkle(e.clientX, e.clientY);
        lastTime = now;
        lastX = e.clientX;
        lastY = e.clientY;
      }
    };

    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, [spawnSparkle]);

  return null;
}
